import client from 'app/domains/apollo';
import { getAssistantQuery } from './query';
export const readAssistantCache = (documentId) => {
    const query = client.readQuery({
        query: getAssistantQuery,
        variables: { documentId },
    });
    return query === null || query === void 0 ? void 0 : query.assistant;
};
